import API from 'services/API';

export default function saveProfile(data) {
  return API.request({
    method: 'POST',
    url: '/profile/saveProfileSettings',
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
